/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S16_Link_AydinlatmaInputs */

const tr_mesafeli_s16_link_aydinlatma = /** @type {(inputs: Mesafeli_S16_Link_AydinlatmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Aydınlatma Metni`)
};

const en_mesafeli_s16_link_aydinlatma = /** @type {(inputs: Mesafeli_S16_Link_AydinlatmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK Information Notice`)
};

const de_mesafeli_s16_link_aydinlatma = /** @type {(inputs: Mesafeli_S16_Link_AydinlatmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KVKK-Informationstext`)
};

const ru_mesafeli_s16_link_aydinlatma = /** @type {(inputs: Mesafeli_S16_Link_AydinlatmaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информационный текст KVKK`)
};

/**
* | output |
* | --- |
* | "KVKK Information Notice" |
*
* @param {Mesafeli_S16_Link_AydinlatmaInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s16_link_aydinlatma = /** @type {((inputs?: Mesafeli_S16_Link_AydinlatmaInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S16_Link_AydinlatmaInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s16_link_aydinlatma(inputs)
	if (locale === "de") return de_mesafeli_s16_link_aydinlatma(inputs)
	if (locale === "ru") return ru_mesafeli_s16_link_aydinlatma(inputs)
	return tr_mesafeli_s16_link_aydinlatma(inputs)
});